import { gql } from "@apollo/client";

export const RECORD_CITATION_PAYMENT = gql`
  mutation RecordCitationPayment($id: uuid!, $paidAmount: Int!, $paidAt: timestamptz!) {
    record_citation_payment(id: $id, paid_amount: $paidAmount, paid_at: $paidAt) {
      id
      citationId: citation_id
      paidAmount: paid_amount
      paidAt: paid_at
      paymentTransactionId: payment_transaction_id
      createdAt: created_at
      updatedAt: updated_at
    }
  }
`;

export interface RecordCitationPaymentData {
  record_citation_payment: {
    id: string;
    citationId: string;
    paidAmount: number;
    paidAt: string;
    paymentTransactionId: string;
    createdAt: string;
    updatedAt: string;
  };
}

export interface RecordCitationPaymentVars {
  id: string;
  paidAmount: number;
  paidAt: Date;
}

export default RECORD_CITATION_PAYMENT;
